import React from "react";
import { Box, IconButton, styled } from "@mui/material";

import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import TableChartIcon from "@mui/icons-material/TableChartOutlined";
import {
  BodySmall,
  H7TitleLarge,
  LabelLarge,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import {
  StyledIconButton,
  SecondaryButton,
  PrimaryButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import usePoolsPageContext from "../../context/usePoolsPageContext.js";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { useHistory, Link } from "react-router-dom";
import AddPoolConfigDialog from "../AddPoolConfigDialog/AddPoolConfigDialog.js";
import { add } from "date-fns";
import useSiteAndGroupTreeContext from "../../../minerstatusV2/context/useSiteAndGroupTreeContext.js";
import { usePostSiteConfig } from "../../queries/usePostSiteConfig.ts";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

export const PoolsPageHeader = (props) => {
  const { data, role, accessLists, configData, refetch } =
    props;
  const { openAddConfigModal, setOpenAddConfigModal } =
    usePoolsPageContext();
  const { colors } = useTheme();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();

  const addPoolsButtonEnabled = () => {
    let roleLevelEnabled = false;
    let poolLengthLessThanThree = false;
    if (role === "superadmin") {
      roleLevelEnabled = true;
    } else if (role === "pooladmin") {
      roleLevelEnabled = true;
    } else if (role === "user") {
      roleLevelEnabled = false;
    } else if (role === "admin") {
      roleLevelEnabled = false;
    }
    if (data?.length < 3) {
      poolLengthLessThanThree = true;
    }
    return roleLevelEnabled && poolLengthLessThanThree;
  };

  const history = useHistory();

  return (
    <Box
      className={"table-container-header"}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
        gap={2}
      >
        {siteSelectedName ? (
          <>
            <H7TitleLarge>
              {!groupSelectedName
                ? `${siteSelectedName} Pool configuration`
                : `${siteSelectedName} - ${groupSelectedName} Pool configuration`}
            </H7TitleLarge>
            <BodySmall>
              Configure up to 3 mining pools for all miners
              in this site. The list is ordered by priority
              from highest to lowest.
            </BodySmall>
          </>
        ) : (
          <></>
        )}
      </Box>
      <Box display={"flex"} flexDirection={"row"} gap={2}>
        <Box
          className={"action-container"}
          display={"flex"}
          flexDirection={"row"}
          gap={2}
        >
          <Link
            to={
              ["superadmin", "pooladmin"].includes(role)
                ? "/pools/whitelist"
                : "#"
            }
            style={{
              textDecoration: "none",
              pointerEvents:
              !["superadmin", "pooladmin"].includes(role) ? "none" : "auto",
              opacity: !["superadmin", "pooladmin"].includes(role) ? 0.5 : 1,
            }}
            tabIndex={!["superadmin", "pooladmin"].includes(role) ? -1 : 0}
          >
            <SecondaryButton colors={colors}
              disabled={!["superadmin", "pooladmin"].includes(role)}
              // onClick={() =>
              //   history.push("/pools/whitelist/")
              // }
            >
              Whitelist Pools
            </SecondaryButton>
          </Link>
          {/* {siteSelectedName && (
            <>
              <PrimaryButton colors={colors}
                disabled={!addPoolsButtonEnabled()}
                onClick={() => setOpenAddConfigModal(true)}
              >
                <Box
                  display={"flex"}
                  gap={2}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <LabelLarge
                    sx={{
                      color: !addPoolsButtonEnabled()
                        ? "#000"
                        : "#ffffff",
                    }}
                  >
                    Add
                  </LabelLarge>
                  <AddRoundedIcon
                    sx={{
                      color: !addPoolsButtonEnabled()
                        ? "#000"
                        : "#ffffff",
                      opacity: !addPoolsButtonEnabled()
                        ? 0.38
                        : 1,
                    }}
                  />
                </Box>
              </PrimaryButton>
            </>
          )} */}
        </Box>
      </Box>
      <AddPoolConfigDialog
        accessLists={accessLists}
        configData={configData}
        refetch={refetch}
      />
    </Box>
  );
};
